import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useChannelEventListener } from "@activecollab/activecollab-react-pusher";
import { makeLoggedUserRealTimeChannelNameSelector } from "~/store/selectors/selector.realTime";

export const useGlobalPrivateChannelListener = (eventName, eventHandler) => {
  const getLoggedUserRealTimeChannelName = useMemo(makeLoggedUserRealTimeChannelNameSelector, []);

  const channelName = useSelector(getLoggedUserRealTimeChannelName);

  useChannelEventListener(eventName, eventHandler, channelName);
};
